var SearchByDateRangeValidate = $.extend({/* SearchByDateRangeValidate */}, BaseComponent, {

	componentSelector: '#search-movements',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				range_date_from: {
				  required: true
				},
				range_date_to: {
				  required: true
				}									
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
                error.insertAfter((element).parents('.input-with-icon-calendar'));
            }
		});

		$(element).find('#search-by-date-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));

	}

})